import { createFileRoute } from "@tanstack/react-router";
import BrandPage from "@/pages/BrandPage";
import { pageHead } from "@/lib/routeHead";

export const Route = createFileRoute("/product-palomino/")({
  head: () => pageHead({ title: 'Palomino RVs', description: 'Shop Palomino RVs at Rex & Sons RVs in Castle Hayne, NC.', path: '/product-palomino' }),
  component: BrandPage,
});